import "@hotwired/turbo-rails"
import "./controllers"
import "materialize-css"

import React from "react"
import { createRoot } from "react-dom/client"
// import HelloWorld from "./components/App"

document.addEventListener("turbo:load", () => {
  // const rootEl = document.getElementById("react-root")
  // if (rootEl) {
  //   const root = createRoot(rootEl)
  //   root.render(<App />)
  // }

  var pelems = document.querySelectorAll('.parallax');
  M.Parallax.init(pelems);

  const selems = document.querySelectorAll(".sidenav")
  M.Sidenav.init(selems)
})